/* Keeps the WhatsApp button's product message in sync with the selected
   variant on product pages (snippets/skdg-whatsapp-button.liquid). */
(function () {
  const button = document.querySelector('.skdg-whatsapp[data-wa-base-url]');
  if (!button || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const { waNumber, waIntro, waTitle, waOption, waBaseUrl, waMoneyFormat } = button.dataset;

  const formatMoney = (cents) => {
    const amount = cents / 100;
    const formatted = amount.toLocaleString('en-IN', {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
    return (waMoneyFormat || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, formatted);
  };

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data && event.data.variant;
    if (!variant) return;

    const lines = [];
    if (waIntro) lines.push(waIntro);
    lines.push(`Product: ${waTitle}`);
    if (waOption) lines.push(`${waOption}: ${variant.title}`);
    lines.push(`Price: ${formatMoney(variant.price)}`);
    lines.push(`Link: ${waBaseUrl}?variant=${variant.id}`);

    button.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(lines.join('\n'))}`;
  });
})();
